import React from 'react';
import PropTypes from 'prop-types';
import Image from 'react-bootstrap/Image';
import isNil from 'ramda/src/isNil';
import isEmpty from 'ramda/src/isEmpty';

const LandingComment = ({ comment = '', name = '', avatar = '', company = '', role = '' }) => (
    <div className="landing-comment">
        <div className="comment-detail">
            <h3 className="dsl-b16 l-height-22 text-center">
                &quot;
                {comment}
                &quot;
            </h3>
        </div>
        <div className="d-flex ai-center p-3">
            <Image className="mr-3" src={isNil(avatar) || isEmpty(avatar) ? '/images/default.png' : '/images/comments/' + avatar} width={44} height={44} roundedCircle />
            <div className="commentor-detail">
                <p className="dsl-b16 bold mb-0">{name}</p>
                <p className="dsl-d12 mb-0">{role}</p>
                <p className="dsl-d12 mb-0">{company}</p>
            </div>
        </div>
    </div>
);

LandingComment.propTypes = {
    comment: PropTypes.string,
    name: PropTypes.string,
    avatar: PropTypes.string,
    company: PropTypes.string,
    role: PropTypes.string,
};

export default LandingComment;
